export default __webpack_public_path__ + "static/media/BillImage.b1719db3.png";